module.exports = __webpack_public_path__ + "static/4-3957adf584b74d3819c9ae4015628f82.jpg";